import {ColumnData} from "../../components/styledTable/useCreateColumns";

export function buildColumnData(): ColumnData[] {
  return [
    {
      id: "name",
      columnHeader: "Name",
      accessorFn: (row) => row.name,
    },
    {id: "count", columnHeader: "Count", accessorFn: (row) => row.count},
  ];
}

export function getTotalCount(rows: {count: number}[]) {
  return rows.reduce((sum, row) => sum + row.count, 0);
}
